import { ActivityStepDraft } from "./activityStepTypes";
import { detectTimerDuration } from "./activityStepsParser";

export interface ActivityStepValidation {
  ready: boolean;
  messages: string[];
}

export function validateActivityStep(
  step: ActivityStepDraft,
): ActivityStepValidation {
  const messages: string[] = [];
  if (!step.text.trim()) messages.push("Add an instruction.");
  if (step.type === "image" && !step.imageName.trim()) {
    messages.push("Add the image name referenced by this step.");
  }
  if (step.type === "video") {
    if (!step.url.trim()) {
      messages.push("Add a video URL.");
    } else {
      try {
        const parsed = new URL(step.url);
        if (parsed.protocol !== "http:" && parsed.protocol !== "https:") {
          messages.push("Use an http or https video URL.");
        }
      } catch {
        messages.push("Add a valid video URL.");
      }
    }
  }
  if (step.type === "timer") {
    const duration = detectTimerDuration(step.text);
    if (duration.hasConflict) {
      messages.push("Use one unambiguous duration in this timer step.");
    } else if (!duration.hasDuration) {
      messages.push("Include a duration such as “2 minutes” in the instruction.");
    }
  }
  if (step.type === "qa" && step.text.trim() && !step.text.trim().endsWith("?")) {
    messages.push("End the question with a question mark.");
  }
  return { ready: messages.length === 0, messages };
}

export function activityStepsAreReady(steps: readonly ActivityStepDraft[]) {
  return steps.length > 0 && steps.every((step) => validateActivityStep(step).ready);
}
